import React from 'react';
import { FlameIcon } from 'lucide-react';
type ScarcityBarProps = {
  tone?: 'light' | 'dark';
  spotsLeft?: number;
  totalSpots?: number;
  className?: string;
};
export function ScarcityBar({
  tone = 'light',
  spotsLeft = 14,
  totalSpots = 200,
  className = ''
}: ScarcityBarProps) {
  const claimed = totalSpots - spotsLeft;
  const percent = Math.round(claimed / totalSpots * 100);
  const isDark = tone === 'dark';
  return <div className={`w-full rounded-2xl border p-4 sm:p-5 ${isDark ? 'border-gold/25 bg-ink-soft' : 'border-gold/30 bg-gold-pale/70'} ${className}`} data-id="element-237" data-mp="2b56xyrdpzrl5">
      <div className="flex items-center justify-between gap-3" data-id="element-238" data-mp="2273o4sc3kj96">
        <p className={`flex items-center gap-1.5 text-[12px] font-extrabold uppercase tracking-[0.1em] ${isDark ? 'text-gold-light' : 'text-alert'}`} data-id="element-239" data-mp="27552izykvueb">
          <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-240" data-mp="5ds0qjrwq2mh" />
          Launch pricing
        </p>
        <p className={`text-[12px] font-bold tabular-nums ${isDark ? 'text-cream/80' : 'text-ink/70'}`} data-id="element-241" data-mp="33mv8ioabtj7u">
          {percent}% claimed
        </p>
      </div>

      <div className={`mt-3 h-3 w-full overflow-hidden rounded-full ${isDark ? 'bg-cream/15' : 'bg-ink/10'}`} role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={percent} aria-label="Promotional spots claimed" data-id="element-242" data-mp="2zkrtxqsd1yic">
        <div className="h-full rounded-full bg-alert" style={{
        width: `${percent}%`
      }} data-id="element-243" data-mp="2koscvqn9wo12" />
      </div>

      <p className={`mt-3 text-[13px] font-semibold leading-snug ${isDark ? 'text-cream/85' : 'text-ink/80'}`} data-id="element-244" data-mp="2goi82hb7w3ns">
        Only <span className="text-alert" data-id="element-245" data-mp="2uju54vcui67v">{spotsLeft} spots left</span> at the promotional price of $27.
      </p>
    </div>;
}